import { Admin } from "@digital-girls-hub/shared-resources/models/db";

export const ADMIN_ROLE = {
  SUPER_ADMIN: "super_admin",
  CENTRAL_ADMIN: "central_admin",
  ADMIN: "admin",
  STATE_ADMIN: "state_admin",
  PP_ADMIN: "pp_admin",
} as const;

export type AdminRole = (typeof ADMIN_ROLE)[keyof typeof ADMIN_ROLE];

export const resolveAdminRole = (
  admin?: Pick<Admin, "type">
): AdminRole | undefined => {
  if (!admin?.type) return undefined;
  if (admin.type === "super") return ADMIN_ROLE.SUPER_ADMIN;
  if (admin.type === "admin") return ADMIN_ROLE.CENTRAL_ADMIN;
  if (admin.type === "viewer_admin") return ADMIN_ROLE.ADMIN;
  if (admin.type === "pp_admin") return ADMIN_ROLE.PP_ADMIN;
  return ADMIN_ROLE.STATE_ADMIN;
};

export const canUploadDocuments = (role?: AdminRole) =>
  role === ADMIN_ROLE.SUPER_ADMIN || role === ADMIN_ROLE.CENTRAL_ADMIN;

export const hasFullLearnerAccess = (role?: AdminRole) =>
  role === ADMIN_ROLE.SUPER_ADMIN || role === ADMIN_ROLE.CENTRAL_ADMIN;

export const isSuperAdmin = (role?: AdminRole) =>
  role === ADMIN_ROLE.SUPER_ADMIN;

export const isCentralAdmin = (role?: AdminRole) =>
  role === ADMIN_ROLE.CENTRAL_ADMIN;

export const isStateAdmin = (role?: AdminRole) =>
  role === ADMIN_ROLE.STATE_ADMIN;

export const isPPAdmin = (role?: AdminRole) =>
  role === ADMIN_ROLE.PP_ADMIN;

export const getRoleLabel = (role?: AdminRole) => {
  if (role === ADMIN_ROLE.SUPER_ADMIN) return "Super Admin";
  if (role === ADMIN_ROLE.CENTRAL_ADMIN) return "Central Admin";
  if (role === ADMIN_ROLE.ADMIN) return "Admin";
  if (role === ADMIN_ROLE.STATE_ADMIN) return "State Admin";
  if (role === ADMIN_ROLE.PP_ADMIN) return "PP Admin";
  return "Admin";
};
